<div id="JSFiddle">
  <div *ngIf="chartData?.data?.length > 0" [style.height.px]="chartData.height" [style.width.px]="chartData.width">
    <canvas
      [id]="chartData.id"
      baseChart
      [datasets]="chartData.data"
      [labels]="chartData.labels"
      [legend]="chartData.legend"
      [type]="chartData.type"
      [options]="chartData.options"
    >
    </canvas>
  </div>
</div>
